'use strict';

export default class ShowController {

  /*@ngInject*/
  constructor($http, $stateParams) {
    this.$http = $http;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getApp(this.$stateParams.id);
  }

  getApp(id) {
    this.$http.get('/api/apps/' + id).then(response => {
      this.app = response.data;
    });
  }

  deleteApp(app) {
    if (confirm("确定？")) {
      this.$http.delete('api/apps/' + app._id).then(response => {
        this.getApp();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/apps/show/show.controller.js